import { accountSettingsSlice } from '@domagude/nospen-packages/frontend/redux/accountSettingsPage/accountSettingsSlice';

export const { setAccountSettingsModals, cleanAccountSettingsState } =
  accountSettingsSlice.actions;

export default accountSettingsSlice.reducer;
